const Range = require('../classes/range')
const satisfies = (version, range, options) => {
  try {
    range = new Range(range, options)
  } catch (er) {
    return false
  }
  return range.test(version)
}
module.exports = satisfies



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/satisfies.js
// module id = 242
// module chunks = 0